import { PAYMENT_GATEWAY } from '@adtrackify/at-tracking-event-types';

import { useBillingPaymentMethods } from '@/features/billing/hooks/use-billing-payment-methods';
import { useAccountState } from '@/contexts/account/account-context';

export function PaymentMethodsBootstrap(): null {
  const { currentAccount } = useAccountState();
  const paymentGateway = currentAccount?.subscription?.paymentGateway;
  const isStripeActive = paymentGateway === PAYMENT_GATEWAY.STRIPE;

  useBillingPaymentMethods({ enabled: isStripeActive });

  return null;
}
